<template>
    <div class="item-type-other">
        <document-fallback :item="item" />
    </div>
</template>

<script>
import DocumentFallback from './DocumentFallback';

export default {
    name: 'Document',
    components: {
        DocumentFallback,
    },
    props: {
        item: {
            type: Object,
            required: true
        }
    },
}
</script>

<style lang="scss" scoped>
@import '~/sass/_variables';

.item-type-other {
    height: 100%;
    width: 100%;
}
</style>
